"use client";

import { useEffect } from "react";

import { useWithdrawal } from "@/hooks/withdrawal/use-withdrawal";
import { WithdrawalLayoutContent } from "@/utils/schema/withdrawal-page-schema.utils";

import WithdrawalContent from "./withdrawal-content";

interface WithdrawalPageClientProps {
  content?: WithdrawalLayoutContent;
}

export default function WithdrawalPageClient({
  content,
}: Readonly<WithdrawalPageClientProps>) {
  const {
    policyData,
    isLoadingPolicy,
    requestError,
    fetchPolicyData,
    submitRequest,
  } = useWithdrawal();

  useEffect(() => {
    fetchPolicyData();
  }, []);

  const handleWithdraw = async (withdrawalReason: string) => {
    const result = await submitRequest(withdrawalReason);

    if (result.type.includes("rejected")) {
      throw new Error(requestError || "Withdrawal request failed");
    }
  };

  if (isLoadingPolicy) {
    return (
      <div className="flex items-center justify-center py-spacing-xl">
        <div className="text-center">
          <p className="font-body-font text-base text-text-functional">
            Loading policy data...
          </p>
        </div>
      </div>
    );
  }

  if (!policyData) {
    return (
      <div className="flex items-center justify-center py-spacing-xl">
        <div className="text-center">
          <p className="font-body-font text-base text-text-functional">
            Unable to load policy data. Please try again later.
          </p>
        </div>
      </div>
    );
  }

  return (
    <WithdrawalContent
      content={content}
      data={policyData}
      onWithdraw={handleWithdraw}
    />
  );
}
